import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@ludus/ui'
import { CenteredPanel } from '@/shared/feedback/CenteredPanel.tsx'
import { AuditsListView } from '../AuditsListView/AuditsListView.tsx'
import { CreateAuditWizard } from '../CreateAuditWizard/CreateAuditWizard.tsx'
import { useAudits } from '../hooks/index.ts'

/** `/audits` — the catalogue (§10.1). */
export function AuditsListPage() {
  const { t } = useTranslation()
  const { audits, error, isLoading } = useAudits()
  const [creating, setCreating] = useState(false)

  if (isLoading) {
    return (
      <CenteredPanel
        title={t('pages.audits.list.loading', { defaultValue: 'Loading audits…' })}
        muted
      />
    )
  }
  if (error) {
    return (
      <CenteredPanel
        title={t('pages.audits.list.error.title', { defaultValue: 'Could not load audits' })}
        body={
          error.kind === 'unauthorized'
            ? t('pages.audits.list.error.unauthorized', {
                defaultValue:
                  'The console could not authenticate against the engine. Set a valid bearer token and reload.',
              })
            : t('pages.audits.list.error.generic', {
                defaultValue: 'The engine returned an error while listing audits.',
              })
        }
        meta={error.status !== null ? `HTTP ${error.status} · ${error.message}` : undefined}
        tone="error"
      />
    )
  }

  return (
    <>
      {audits.length === 0 ? (
        <CenteredPanel
          title={t('pages.audits.list.empty.title', { defaultValue: 'No audits yet' })}
          body={t('pages.audits.list.empty.body', {
            defaultValue:
              'Create the first one: pick the pipelines and the period, and the engine freezes the slice.',
          })}
          muted
        >
          <Button variant="primary" size="sm" onClick={() => setCreating(true)}>
            {t('pages.audits.list.newAudit', { defaultValue: 'New audit' })}
          </Button>
        </CenteredPanel>
      ) : (
        <AuditsListView audits={audits} onCreate={() => setCreating(true)} />
      )}
      <CreateAuditWizard open={creating} onOpenChange={setCreating} />
    </>
  )
}
